import { _delete, _get, _post, _put } from "../../http";

// Categorías de Quick Actions. Agrupan las acciones que se muestran en el área
// de chat (location === 'chat') detrás del botón "Categorías" del chatbot.
// NOTA: estos endpoints siguen la misma convención que /lia-api/quick-actions;
// el backend aún debe implementarlos. Mientras no existan, las llamadas fallarán
// y el frontend degrada de forma segura (lista vacía).
export const getQuickActionCategories = () => _get(`/lia-api/quick-action-categories`);

export const createQuickActionCategory = (body) => _post(`/lia-api/quick-action-categories`, body);

export const updateQuickActionCategory = (id, body) => _put(`/lia-api/quick-action-categories/${id}`, body);

export const deleteQuickActionCategory = (id) => _delete(`/lia-api/quick-action-categories/${id}`);
